export default {
  container: 'px-[20px] mt-[24px] mb-[150px] bg-black',
  title: 'md:hidden mb-[20px] font-interSemibold text-[24px] text-[#101828]',
  header: 'flex flex-wrap gap-4 justify-between',
  tabs: 'min-w-[275px]',
  datePicker:
    'w-[260px] flex items-center gap-[10px] h-[42px] px-[14px] border border-[#CCDCE8] rounded-lg font-interMedium text-[14px] text-[#585D69] hover:brightness-90',
  surveyTable: 'md:max-w-[calc(100vw-276px)] overflow-x-auto',
  footer:
    'w-[100%] flex flex-wrap gap-4 items-center justify-between mt-[24px]',
  dropdownWrapper: 'flex gap-[12px] items-center',
  show: 'font-interMedium text-[14px] text-color-text',
  dropdownLabel:
    'flex items-center gap-[15px] h-[42px] px-[14px] border border-[#CCDCE8] rounded-lg font-interMedium text-[14px] text-[#585D69] cursor-pointer',
  dropdownItems:
    'flex-col py-[8px] px-[14px] font-interMedium border border-[#CCDCE8] text-[14px] rounded-lg',
  dropdownItem: 'cursor-pointer p-[10px] rounded-lg',
  addNewButton: '!w-fit border-[#CCDCE8] bg-[#E7E8EA] h-[44px] mr-auto',
  addNewButtonText: '!text-[#70747E] text-[14px]',
  analyticsButton: 'h-[44px] px-[12px] !w-fit rounded-lg',
  selectInput: 'h-[42px] min-w-[260px] sm:min-w-[12em] w-max cursor-pointer',
  clear: 'flex items-center cursor-pointer hover:text-[#585D69] h-[42px] hover:bg-[#E7ECF2] px-3 rounded-lg w-fit mb-4',
};
